namespace Gamification.Gamification {
    export interface TipologieProdottiRow {
        UserId?: number;
        TenantId?: number;
        IdTipologiaProdotti?: number;
        Nome?: string;
        Descrizione?: string;
    }

    export namespace TipologieProdottiRow {
        export const idProperty = 'IdTipologiaProdotti';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.TipologieProdotti';
        export const lookupKey = 'Gamification.TipologieProdotti';

        export function getLookup(): Q.Lookup<TipologieProdottiRow> {
            return Q.getLookup<TipologieProdottiRow>('Gamification.TipologieProdotti');
        }
        export const deletePermission = 'Role:SuperAdmin';
        export const insertPermission = 'Role:SuperAdmin';
        export const readPermission = 'Gamification:Configurazione:View';
        export const updatePermission = 'Role:SuperAdmin';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdTipologiaProdotti = "IdTipologiaProdotti",
            Nome = "Nome",
            Descrizione = "Descrizione"
        }
    }
}
